export default __webpack_public_path__ + "static/media/error.992152fd.png";